import { SectionBuilder } from '../../components/SectionBuilder';
import { useSection } from '../../useSection';
import ProdCatEditor from './ProdCatEditor';

export default function NetworkAplience({ refreshKey, onRegisterSave, onRegisterDirty, onBack }) {
  const { data, setField, saveSection, isDirty } =
    useSection('product:na', 'domain-header', 0);

  const domainSection = (
    <div style={{ marginBottom: 28, paddingBottom: 28, borderBottom: '1px solid #e5e7eb' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
        <span style={{ fontSize: 14, fontWeight: 600 }}>도메인 헤더</span>
        <span style={{ fontSize: 12, color: '#888' }}>홈페이지 제품 목록 위에 표시되는 콘텐츠</span>
      </div>
      <SectionBuilder value={data.content || ''} onChange={v => setField('content', v)} />
    </div>
  );

  return (
    <ProdCatEditor
      slug="na" title="Network Appliance (NA)"
      domainSection={domainSection} domainSave={saveSection} domainDirty={isDirty}
      refreshKey={refreshKey} onRegisterSave={onRegisterSave} onRegisterDirty={onRegisterDirty} onBack={onBack}
    />
  );
}
